<template>
  <div class="email-paginated-overview" v-bind:class="{loaded: loaded}">
    <div style="padding: 0 5px; line-height: 45px;">
      <div class="per-page"
           style="display: inline-block; margin-left: 5px;">
        Per pagina
        <a-select v-bind:disabled="loading" v-model="perPage" style="width: 70px;" v-on:change="onPerPageChange">
          <a-select-option v-bind:value="15">15</a-select-option>
          <a-select-option v-bind:value="30">30</a-select-option>
          <a-select-option v-bind:value="50">50</a-select-option>
        </a-select>
      </div>
      <overview-filter-component v-bind:filter-box="true" v-bind:filter-date-range="true"
                                 v-bind:filter-key-word="true" v-bind:filter-user="true"
                                 v-bind:customer-id="customerId"
                                 v-bind:disabled="loading"
                                 v-on:filter-request="getFilteredEmails($event)"
      />
      <div>
        <laravel-pagination v-if="displayPagination"
                            v-bind:data="currentRequestData"
                            style="margin: 0 0 5px 0;"
                            v-on:pagination-change-page="loadPage"
        ></laravel-pagination>
      </div>
    </div>

    <lazy-component v-on:intersected="onInit" v-bind:is-intersected="forceIntersect">
      <table class="table table-striped">
        <thead v-bind:class="{ loading: loading }">
        <tr v-if="hasEmails && isLoaded">
          <th>
            <order-by v-bind:order="order" v-bind:select="orderBy" value="subject" v-on:change="onOrderByChange">
              Onderwerp
            </order-by>
          </th>
          <th class="compact">
            <order-by v-bind:order="order" v-bind:select="orderBy" value="user_id" v-on:change="onOrderByChange">
              Behandelaar
            </order-by>
          </th>
          <th class="compact">
            <order-by v-bind:order="order" v-bind:select="orderBy" value="customer_id" v-on:change="onOrderByChange">
              Klant
            </order-by>
          </th>
          <th class="compact">
            <order-by v-bind:order="order" v-bind:select="orderBy" class="date" value="date"
                      v-on:change="onOrderByChange">
              Datum
            </order-by>
          </th>
          <th class="compact"></th>
        </tr>
        <tr v-if="!hasEmails && filterActive">
          <th class="compact">
            Er zijn geen emails gevonden die voldoen aan de actieve filters.
          </th>
        </tr>
        </thead>
        <tbody v-bind:class="{ loading: loading }">
        <RowComponent
            v-for="email in emails"
            v-bind:key="email.id"
            v-bind:email="email"
            v-bind:show-breadcrumbs="true"
            @onDeleted="onDeleted"
        ></RowComponent>
        </tbody>
      </table>

      <div v-if="!hasEmails && isLoaded && !filterActive && !loading" style="padding: 0 10px 15px;">
        Deze klant heeft nog geen emails.
      </div>

      <div v-if="displayPagination" style="padding: 8px">
        <laravel-pagination
            v-if="displayPagination"
            v-bind:data="currentRequestData"
            style="margin: 0;"
            v-on:pagination-change-page="loadPage"
        ></laravel-pagination>
      </div>
    </lazy-component>

    <div v-if="!loaded" style="padding:8px;">
      <Skeleton class="skeleton"
                v-bind:loading="true"
                style="width: 97px;height: 35px;display: block;margin-bottom: 10px;"></Skeleton>
      <Skeleton class="skeleton" v-bind:loading="true"
                style="width: 100%;height: 30px;display: block;margin-bottom: 10px;"></Skeleton>
      <Skeleton class="skeleton" v-bind:loading="true"
                style="width: calc(57% - 10px); height: 20px; margin-right: 10px; display: inline-block;"></Skeleton>
      <Skeleton class="skeleton" v-bind:loading="true"
                style="width: calc(10% - 10px); height: 20px; margin-right: 10px; display: inline-block;"></Skeleton>
      <Skeleton class="skeleton" v-bind:loading="true"
                style="width: calc(10% - 10px); height: 20px; margin-right: 10px; display: inline-block;"></Skeleton>
      <Skeleton class="skeleton" v-bind:loading="true"
                style="width: calc(10% - 10px); height: 20px; margin-right: 10px; display: inline-block;"></Skeleton>
      <Skeleton class="skeleton" v-bind:loading="true"
                style="width: 10%; height: 20px; display: inline-block;"></Skeleton>
    </div>
  </div>
</template>

<script>
import emailApi from '~/api/email'
import customerApi from '~/api/customer'
import OverviewFilterComponent from './OverviewFilterComponent'
import RowComponent from './RowComponent'
import { Skeleton } from 'vue-loading-skeleton'
import { mapGetters } from 'vuex'

export default {
  name: 'CustomerPaginatedOverviewComponent',
  props: {
    customerId: {
      type: [String, Number],
      required: true,
    },
  },
  components: {
    RowComponent,
    OverviewFilterComponent,
    Skeleton,
  },
  data () {
    return {
      previousSelectedAttachable: null,
      showMoveModal: false,
      showCopyModal: false,
      showUploadModal: false,
      emailCategoryValue: null,
      reloadTimeout: null,
      emails: [],
      moveEmails: [],
      copyEmails: [],
      currentPage: null,
      currentRequestData: null,
      allSelected: false,
      loading: true,
      loaded: false,
      page: 1,
      perPage: 15,
      orderBy: 'date',
      order: 'desc',
      filter: {},
      selectedEmails: [],
      partnerId: null,
    }
  },
  computed: {
    ...mapGetters([
      'forceIntersect'
    ]),
    displayPagination () {
      return this.isLoaded && this.hasEmails && this.hasPages
    },
    isLoaded () {
      return this.currentRequestData !== null && typeof this.currentRequestData !== 'undefined'
    },
    hasEmails () {
      return this.emails.length > 0
    },
    hasPages () {
      if (this.isLoaded && this.currentRequestData.meta !== null && typeof this.currentRequestData !== 'undefined'
          && this.currentRequestData.meta.pagination !== null
          && typeof this.currentRequestData.meta.pagination !== 'undefined') {
        return this.currentRequestData.meta.pagination.total_pages > 1
      }
      return false
    },
    filterInitialized () {
      return Object.keys(this.filter).length > 0
    },
    filterActive () {
      if (Object.entries(this.filter)) {
        for (const [key, value] of Object.entries(this.filter)) {
          if (value.length > 0) return true
        }
      }
      return false
    }
  },
  methods: {
    async onInit () {
      if (this.customerId !== null) {
        await customerApi.findPartnerByCustomerId(this.customerId)
            .then((response) => {
              this.partnerId = response.data?.id;
            })
            .catch(() => {
              // No partner found
              this.partnerId = null;
            })

        await this.loadPage(1, true);
      } else {
        throw new Error('Klant id mist voor het weergeven van de emails')
      }
    },
    loadPage (page = 1, forceReload = false) {
      if (page === this.currentPage && forceReload !== true) {
        return
      }
      this.loading = true

      let customerIds = [this.customerId];
      if(this.partnerId) {
        customerIds.push(this.partnerId);
      }
      return emailApi.getByCustomersAndFilter(
          customerIds,
          page,
          this.perPage,
          this.orderBy,
          this.order,
          ['customer', 'user'],
          this.filter,
      ).then((response) => {
        this.loaded = true
        this.allSelected = false
        this.emails = response.data
        this.currentRequestData = response
        this.loading = false
        this.currentPage = page
      }).catch(() => {
        this.$notification['error']({
          message: 'Er ging iets mis',
          description: 'Het is niet gelukt om e-mails te laden',
        })
      })
    },
    onPerPageChange (value) {
      if (this.currentTotalItemCount !== null) {
        let newTotalPages = Math.ceil(this.currentTotalItemCount / value)

        if (this.currentPage > newTotalPages) {
          this.page = 1
        } else {
          this.page = this.currentPage
        }
      } else {
        this.page = 1
      }

      this.reloadPage()
    },
    onOrderByChange (orderBy, order) {
      this.orderBy = orderBy
      this.order = order
      this.loadPage(this.currentPage, true)
    },
    reloadPage (page = null) {
      if (page === null) {
        this.page = this.currentPage
      } else {
        this.page = page
      }

      if (this.reloadTimeout !== null) {
        clearTimeout(this.reloadTimeout)
      }

      this.reloadTimeout = setTimeout(() => {
        this.loadPage(this.page, true)
      }, 200)
    },
    reloadOnce () {
      this.loadPage(this.page, true, false)
    },
    getFilteredEmails (params) {
      this.filter = params
      this.loadPage(this.page, true)
    },
    onDeleted() {
      this.loadPage(this.page, true)
    },
  },
  mounted () {
  }
}
</script>

<style scoped>
.email-category-paginated-overview {
  min-height: 50px;
}

.email-category-paginated-overview .table {
  margin-bottom: 0;
}

tr th.half-padding {
  padding: 4px;
}

.padding-top-8 {
  padding-top: 8px;
}

tr.selected {
  background-color: #1890ff1c;
}

table th.compact, table td.compact {
  white-space: nowrap;
  width: 1px !important;
}

table > tbody.loading {
  opacity: 0.5;
}

.loading {
  opacity: 0.5;
}
</style>
